import React, { useEffect } from 'react';

const TradingViewWidget = () => {
  useEffect(() => {
    if (!document.getElementById('tradingview-widget-container').hasChildNodes()) {
      console.log("useEffect runwa")
      const script = document.createElement('script');
      script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-market-quotes.js';
      script.async = true;
      script.innerHTML = JSON.stringify({
        width: 380,
        height: 620,
        symbolsGroups: [
          {
            name: 'Indices',
            originalName: 'Indices',
            symbols: [
              {
                name: 'FOREXCOM:SPXUSD',
                displayName: 'S&P 500',
              },
              {
                  "name": "FOREXCOM:NSXUSD",
                  "displayName": "US 100"
                },
                {
                  "name": "FOREXCOM:DJI",
                  "displayName": "Dow 30"
                },
                {
                  "name": "INDEX:NKY",
                  "displayName": "Nikkei 225"
                },
                {
                  "name": "INDEX:DEU40",
                  "displayName": "DAX Index"
                },
                {
                  "name": "FOREXCOM:UKXGBP",
                  "displayName": "UK 100"
                }
            ],
          },
          {
              "name": "Futures",
              "originalName": "Futures",
              "symbols": [
                {
                  "name": "CME_MINI:ES1!",
                  "displayName": "S&P 500"
                },
                {
                  "name": "CME:6E1!",
                  "displayName": "Euro"
                },
                {
                  "name": "COMEX:GC1!",
                  "displayName": "Gold"
                },
                {
                  "name": "NYMEX:CL1!",
                  "displayName": "WTI Crude Oil"
                },
                {
                  "name": "NYMEX:NG1!",
                  "displayName": "Gas"
                },
                {
                  "name": "CBOT:ZC1!",
                  "displayName": "Corn"
                }
              ]
            },
            
          // Add other symbol groups as needed
        ],
        showSymbolLogo: true,
        isTransparent: false,
        colorTheme: 'light',
        locale: 'en',
      });
      document.getElementById('tradingview-widget-container').appendChild(script);
      console.log("useeffect run 2")
    }
  }, []);
  

  return <div id="tradingview-widget-container"></div>;
};

export default TradingViewWidget;
